// components/Navbar.jsx
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  AiOutlineClose,
  AiOutlineLogout,
  AiOutlineUser,
  AiOutlineHome,
  AiOutlineMessage,
  AiOutlineTeam,
} from 'react-icons/ai';
import { IoMdArrowDropdown } from 'react-icons/io';
import { GiHamburgerMenu } from 'react-icons/gi';
import axios from 'axios';

import { setisLoggedin, setdata } from '../redux/reducers/userSlice';
import styles from '../styles/navbar.module.css';

function Navbar() {
  const { users } = useSelector((state) => state);
  const [profileOpen, setProfileOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isLoggedIn = users?.isloggedin;
  const userData = users?.userdata;

  const handleLogout = async () => {
    try {
      const response = await axios.post('https://chatting-club-backend.onrender.com/api/users/logout', {}, {
        withCredentials: true
      });

      if (response.status === 200 || response.status === 201 || response.status === 204) {
        toast.success(response.data?.message || 'Logged out successfully', {
          position: 'bottom-right',
          theme: 'colored',
        });
      }

      dispatch(setisLoggedin(false));
      dispatch(setdata());
      setProfileOpen(false);
      setMobileMenuOpen(false);
      navigate('/login');
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Logout failed. Please try again.';
      toast.error(errorMessage, {
        position: 'bottom-right',
        theme: 'colored',
      });
    }
  };

  const navigateTo = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
    setProfileOpen(false);
  };

  return (
    <header className={styles.navbar}>
      <div className={styles.container}>
        <button 
          type="button" 
          className={styles.logo} 
          onClick={() => navigateTo('/')} 
          aria-label="Go to homepage"
        >
          <span className={styles.logoMark}>💬</span>
          <span className={styles.logoText}>
            <strong>Chatting Club</strong>
            <small>Connect & Chat</small>
          </span>
        </button>

        {isLoggedIn && (
          <div className={styles.navLinks}>
            <button 
              type="button" 
              className={styles.navLink}
              onClick={() => navigateTo('/')}
            >
              <AiOutlineHome />
              <span>Home</span>
            </button>
            <button 
              type="button" 
              className={styles.navLink}
              onClick={() => navigateTo('/users')}
            >
              <AiOutlineTeam />
              <span>Users</span>
            </button>
            <button 
              type="button" 
              className={styles.navLink}
              onClick={() => navigateTo('/chats')}
            >
              <AiOutlineMessage />
              <span>Chats</span>
            </button>
          </div>
        )}

        <div className={styles.actions}>
          {isLoggedIn ? (
            <div className={styles.profileWrapper}>
              <button
                type="button"
                className={styles.profileButton}
                onClick={() => setProfileOpen(!profileOpen)}
                aria-expanded={profileOpen}
              >
                <span className={styles.userAvatar}>
                  {userData?.name?.charAt(0)?.toUpperCase() || 'U'}
                </span>
                <span className={styles.userName}>{userData?.name || 'My Account'}</span>
                <IoMdArrowDropdown className={`${styles.dropdownIcon} ${profileOpen ? styles.dropdownIconOpen : ''}`} />
              </button>

              {profileOpen && (
                <div className={styles.profileMenu}>
                  <div className={styles.profileMenuHeader}>
                    <strong>{userData?.name || 'User'}</strong>
                    <span>{userData?.email || 'Welcome back'}</span>
                  </div>

                  <button type="button" onClick={() => navigateTo('/profile')}>
                    <AiOutlineUser />
                    My Profile
                  </button>
                  
                  <div className={styles.menuDivider} />

                  <button type="button" className={styles.logoutButton} onClick={handleLogout}>
                    <AiOutlineLogout />
                    Logout
                  </button>
                </div>
              )}
            </div>
          ) : (
            <button 
              type="button" 
              className={styles.signinButton} 
              onClick={() => navigate('/login')}
            >
              <AiOutlineUser />
              <span>Sign in</span>
            </button>
          )}

          {isLoggedIn && (
            <button
              type="button"
              className={styles.mobileMenuToggle}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <AiOutlineClose /> : <GiHamburgerMenu />}
            </button>
          )}
        </div>
      </div>

      {isLoggedIn && mobileMenuOpen && (
        <div className={styles.mobileMenu}>
          <button 
            type="button" 
            className={styles.mobileNavLink}
            onClick={() => navigateTo('/')}
          >
            <AiOutlineHome />
            <span>Home</span>
          </button>
          <button 
            type="button" 
            className={styles.mobileNavLink}
            onClick={() => navigateTo('/users')}
          >
            <AiOutlineTeam />
            <span>Users</span>
          </button>
          <button 
            type="button" 
            className={styles.mobileNavLink}
            onClick={() => navigateTo('/chats')}
          >
            <AiOutlineMessage />
            <span>Chats</span>
          </button>
          
          <div className={styles.mobileDivider} />
          <button 
            type="button" 
            className={styles.mobileNavLink}
            onClick={() => navigateTo('/profile')}
          >
            <AiOutlineUser />
            <span>Profile</span>
          </button>
          <button 
            type="button" 
            className={`${styles.mobileNavLink} ${styles.mobileLogout}`}
            onClick={handleLogout}
          >
            <AiOutlineLogout />
            <span>Logout</span>
          </button>
        </div>
      )}
    </header>
  );
}

export default Navbar;